/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { FlokkurEnum } from '../models/FlokkurEnum';
import { SimpleHorse } from '../models/SimpleHorse';
import { HttpFile } from '../http/http';

export class LandsmotJudgeOverview {
    'number': string;
    'flokkur': FlokkurEnum;
    'horse': SimpleHorse;
    'faedingarnumer': string;
    'name': string;
    'rider': string;
    'trainer': string;
    'skopulag': number;
    'haefileikar': number;
    'adaleinkunn': number;
    'haefileikarAnSkeids': number;
    'adaleinkunnAnSkeids': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "number",
            "baseName": "number",
            "type": "string",
            "format": ""
        },
        {
            "name": "flokkur",
            "baseName": "flokkur",
            "type": "FlokkurEnum",
            "format": ""
        },
        {
            "name": "horse",
            "baseName": "horse",
            "type": "SimpleHorse",
            "format": ""
        },
        {
            "name": "faedingarnumer",
            "baseName": "faedingarnumer",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "rider",
            "baseName": "rider",
            "type": "string",
            "format": ""
        },
        {
            "name": "trainer",
            "baseName": "trainer",
            "type": "string",
            "format": ""
        },
        {
            "name": "skopulag",
            "baseName": "skopulag",
            "type": "number",
            "format": "double"
        },
        {
            "name": "haefileikar",
            "baseName": "haefileikar",
            "type": "number",
            "format": "double"
        },
        {
            "name": "adaleinkunn",
            "baseName": "adaleinkunn",
            "type": "number",
            "format": "double"
        },
        {
            "name": "haefileikarAnSkeids",
            "baseName": "haefileikarAnSkeids",
            "type": "number",
            "format": "double"
        },
        {
            "name": "adaleinkunnAnSkeids",
            "baseName": "adaleinkunnAnSkeids",
            "type": "number",
            "format": "double"
        }    ];

    static getAttributeTypeMap() {
        return LandsmotJudgeOverview.attributeTypeMap;
    }

    public constructor() {
    }
}



